import React, { useState, useEffect } from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { APIUrl, APIUrlToken, getIsUser } from "../../Utils/Utils";
import axios from "axios";
import { FaUser } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { toast } from "react-toastify";

const BrandPartnershipType = () => {
  const [step, setStep] = useState(1);
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [specialInstructions, setSpecialInstructions] = useState("");
  const [selectedPricing, setSelectedPricing] = useState("");
  const [multipleRequests, setMultipleRequests] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const [totalAmountCheckout, setTotalAmountCheckout] = useState("");

  const {
    playerId,
    teamId,
    playerName,
    pricingOptionsList,
    dataBrandExperience,
  } = location.state || {};
  const assignedAmount = location.state?.sectionValue;
  const [assignedAmountNav] = useState(assignedAmount);
  const engagementTypeFromNav = location.state?.type;

  const engagementType = location.state?.checkoutType;

  const [fanEngagementTypeNavigate] = useState(engagementTypeFromNav);

  const [brandEngagementTypeNavigate] = useState(engagementType);

  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    companyname: "",
    phoneno: "",
    email: "",
  });

  // Match current type
  const currentData =
    dataBrandExperience.find(
      (item) => item.fanEngagementType === engagementTypeFromNav
    ) || dataBrandExperience[0];
  const selectedFanTypeData = dataBrandExperience.find(
    (item) => item.fanEngagementType === fanEngagementTypeNavigate
  );
  const SocialMediaPlatform = selectedFanTypeData?.platforms || [];
  const FanEngagementDetails = {
    description: selectedFanTypeData?.description || "",
    example: selectedFanTypeData?.example || "",
    label: selectedFanTypeData?.specialInstructionsLabel || "Enter details:",
  };
  const steps = [
    "Select Social Media Platform",
    "Provide Details of Brand Partnership",
    "Checkout Details & Payment",
  ];

  const nextStep = () => {
    if (step < steps.length) setStep(step + 1);
    if (step === 3) {
      handleSubmitFanEngagement();
    }
  };

  const prevStep = () => {
    if (step > 1) setStep(step - 1);
  };

  const handlePricingSelect = (option) => {
    setSelectedPricing(option);
    if (option !== "Multiple Requests (please specify)") {
      setMultipleRequests("");
    }
  };
  const PricingOptions = selectedFanTypeData?.pricingOptions || [];

  const progressWidth = `${(step / steps.length) * 100}%`;

  const isNextDisabled =
    (step === 1 && !selectedPlatform) ||
    (step === 2 && !specialInstructions.trim());
  useEffect(() => {
    const selectedOption = PricingOptions.find(
      (p) => p.pricingText === selectedPricing
    );

    const assignedNum = Number(
      String(assignedAmountNav || "").replace(/[^0-9.]/g, "")
    );
    const rawBase = (() => {
      const assignedNum = Number(
        String(assignedAmountNav || "").replace(/[^0-9.]/g, "")
      );

      if (!isNaN(assignedNum) && assignedNum > 0) {
        return `$${assignedNum}`;
      }
      return (
        pricingOptionsList?.config?.[fanEngagementTypeNavigate]?.sectionValue ||
        "$1000"
      );
    })();

    const baseNum = Number(String(rawBase).replace(/[^0-9.]/g, ""));
    const selectedValue = selectedOption?.pricingValue || "";
    const selectedNum = Number(selectedValue.replace(/[^0-9.]/g, ""));
    if (!selectedOption || !selectedNum) {
      setTotalAmountCheckout(rawBase);
      return;
    }

    // 1️⃣ PRIORITY: assignedAmountNav has valid number
    if (!isNaN(assignedNum) && assignedNum > 0) {
      const total = assignedNum + selectedNum;
      setTotalAmountCheckout(`$${total}`);
      return;
    }

    // 2️⃣ FALLBACK: assignedAmountNav invalid → use baseNum
    const total = baseNum + selectedNum;
    setTotalAmountCheckout(`$${total}`);
  }, [
    selectedPricing,
    pricingOptionsList,
    fanEngagementTypeNavigate,
    assignedAmountNav,
  ]);

  const getStepContent = () => {
    switch (step) {
      case 1:
        return (
          <div className="fan-step">
            <h3>{steps[0]}</h3>
            <div className="fan-platforms">
              {currentData.platforms.map((platform, index) => (
                <label key={index} className="fan-option">
                  <input
                    type="radio"
                    name="platform"
                    value={platform}
                    checked={selectedPlatform === platform}
                    onChange={(e) => setSelectedPlatform(e.target.value)}
                  />
                  <span>{platform}</span>
                </label>
              ))}
            </div>
          </div>
        );

      case 2:
        return (
          <div className="fan-step">
            <h3>{steps[1]}</h3>
            <p className="fan-description">{currentData.description}</p>
            <div className="fan-field">
              <label>{currentData.specialInstructionsLabel}</label>
              <textarea
                className="fan-input"
                placeholder="Enter any special instructions..."
                value={specialInstructions}
                onChange={(e) => setSpecialInstructions(e.target.value)}
              />
            </div>
          </div>
        );

      case 3:
        return (
          <div className="fan-step">
            <h3>{steps[2]}</h3>

            {/* ---------- Primary Details ---------- */}
            {!userLoginDetails?.user_id ? (
              <>
                <div className="section-title-accountInfo">Primary Details</div>
                <div className="first-section-my-profile">
                  <div className="input-section-accountInfo">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <FaUser />
                      </div>
                      <input
                        type="text"
                        className="form-control-accountInfo"
                        name="firstname"
                        placeholder="First Name"
                        value={formData.firstname}
                        onChange={handleChange}
                        disabled={!!userLoginDetails?.user_id}
                      />
                    </div>
                  </div>

                  <div className="input-section-accountInfo">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <FaUser />
                      </div>
                      <input
                        type="text"
                        className="form-control-accountInfo"
                        name="lastname"
                        placeholder="Last Name"
                        value={formData.lastname}
                        onChange={handleChange}
                        disabled={!!userLoginDetails?.user_id}
                      />
                    </div>
                  </div>
                </div>
                <div className="first-section-my-profile-company">
                  <div className="input-section-accountInfo-company">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <FaUser />
                      </div>
                      <input
                        type="text"
                        className="form-control-accountInfo"
                        name="companyname"
                        placeholder="Company Name"
                        value={formData.companyname}
                        onChange={handleChange}
                        disabled={!!userLoginDetails?.user_id}
                      />
                    </div>
                  </div>
                </div>
                <div className="first-section-my-profile">
                  <div className="input-section-accountInfo">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <FaPhoneAlt />
                      </div>
                      <input
                        type="text"
                        className="form-control-accountInfo"
                        name="phoneno"
                        placeholder="Phone Number"
                        value={formData.phoneno}
                        onChange={handleChange}
                        disabled={!!userLoginDetails?.user_id}
                      />
                    </div>
                  </div>

                  <div className="input-section-accountInfo">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <MdEmail />
                      </div>
                      <input
                        type="text"
                        className="form-control-accountInfo"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        disabled={!!userLoginDetails?.user_id}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : null}

            <hr />

            {/* ---------- Requested Details ---------- */}
            <div className="section-title-accountInfo">Requested Details</div>
            <div className="fetc-st4">
              <div className="viewmore-fan-brand-athlete">
                <strong>Brand Partnership Type:</strong>{" "}
                {brandEngagementTypeNavigate}
              </div>
              <div className="viewmore-fan-brand-athlete">
                <strong>Selected Platform:</strong> {selectedPlatform}
              </div>
              <div className="viewmore-fan-brand-athlete">
                <strong>Instructions for Athlete:</strong>{" "}
                {specialInstructions || "—"}
              </div>
              {multipleRequests && (
                <div className="viewmore-fan-brand-athlete">
                  <strong>Additional Requests:</strong> {multipleRequests}
                </div>
              )}
            </div>

            <hr />

            {/* ---------- Pricing Details ---------- */}
            <div className="section-title-accountInfo">Pricing Details</div>
            <div className="fetc-st4">
              <div className="viewmore-fan-brand-athlete">
                <strong>Total:</strong>{" "}
                {(() => {
                  const pricingValue = PricingOptions.find(
                    (p) => p.pricingText === selectedPricing
                  )?.pricingValue;

                  // If value starts with "$", clean it
                  if (
                    typeof pricingValue === "string" &&
                    pricingValue.startsWith("$")
                  ) {
                    return pricingValue.replace("+", "");
                  }

                  // Clean + from assignedAmountNav also (if it's a string)
                  if (typeof assignedAmountNav === "string") {
                    return assignedAmountNav.replace("+", "");
                  }

                  return assignedAmountNav;
                })()}
              </div>
            </div>

            <hr />
          </div>
        );

      default:
        return null;
    }
  };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  let userLoginDetails = getIsUser();
  const getNumericAmount = (value) => {
    if (!value) return 0;
    let str = String(value).trim();
    str = str.replace(/[^0-9.]/g, "");
    return Number(str) || 0;
  };

  const handleSubmitFanEngagement = () => {
    if (!userLoginDetails?.user_id) {
      if (!formData.firstname) {
        toast.error("Please enter first name");
        return;
      }
      if (!formData.lastname) {
        toast.error("Please enter last name");
        return;
      }
      if (!formData.companyname) {
        toast.error("Please enter company name");
        return;
      }
      if (!formData.phoneno) {
        toast.error("Please enter phone no");
        return;
      }
      if (!formData.email) {
        toast.error("Please enter email");
        return;
      }
    }
    let data = {
      fan_engagement_type: fanEngagementTypeNavigate,
      social_media_platform: selectedPlatform,
      engagement_details: specialInstructions,
      message_to_athlete: multipleRequests,
      pricing_options: [
        {
          type: selectedPricing,
          amount: PricingOptions.find(
            (p) => p.pricingText === selectedPricing
          )?.pricingValue.startsWith("$")
            ? PricingOptions.find((p) => p.pricingText === selectedPricing)
                ?.pricingValue
            : assignedAmountNav,
        },
      ],
      user_id: userLoginDetails?.user_id,
      player_id: playerId,
    };
    if (userLoginDetails?.user_id) {
      data.user_id = userLoginDetails?.user_id;
      data.user_email = userLoginDetails?.user_email;
    } else {
      data.user_id = 0;
      data.user_first_name = formData.firstname;
      data.user_last_name = formData.lastname;
      data.brand_name = formData.companyname;
      data.user_phone_number = formData.phoneno;
      data.user_email = formData.email;
    }
    const url = `${APIUrl()}/v1/brand_engagement_request`;
    const option = {
      method: "POST",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: url,
    };

    axios(option)
      .then(async (response) => {
        const data = response?.data;
        // if (
        //   Number(
        //     PricingOptions?.find(
        //       (i) => i?.pricingText === selectedPricing
        //     )?.pricingValue?.split("$")?.[1]
        //   )
        // ) {
        await handleDonationOnetime(data?.brand_engagement_request_id);
        // } else {
        //   toast.success("Your request submitted Successfully");
        //   navigate("/dashboard/start-your-brand-partnership");
        // }
      })
      .catch((error) => {
        console.error("Error fetching teams data:", error);
      });
  };

  const handleDonationOnetime = async (item) => {
    const priceOption = PricingOptions.find(
      (p) => p.pricingText === selectedPricing
    )?.pricingValue;

    const amountToSend =
      getNumericAmount(priceOption) || getNumericAmount(assignedAmountNav);
    let data = {
      amount: amountToSend,
      nil_service_type: "general_contribution",
      player_id: Number(playerId),
      player_name: playerName,
      team_id: Number(teamId),
      fan_engagement_request_id: 0,
      brand_engagement_request_id: item,
    };

    if (userLoginDetails?.user_id) {
      data.user_id = userLoginDetails?.user_id;
      data.user_email = userLoginDetails?.user_email;
    }

    const url = `${APIUrl()}/v1/create-checkout-session/one_time`;
    const option = {
      method: "POST",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: url,
    };

    axios(option)
      .then((response) => {
        const data = response?.data?.checkout_url || [];
        window.open(data, "_blank");
      })
      .catch((error) => {
        console.error("Error fetching teams data:", error);
      });
  };
  return (
    <>
      <Header />
      <div
        className="arrow-go-back-fan"
        onClick={() => {
          navigate(`/BrandPartnership/${playerId}/${teamId}`);
        }}
      >
        <IoIosArrowRoundBack />
        Go back to Brand Partnership
      </div>

      <div className="fan-container">
        <div className="fan-progress-bar">
          <div
            className="fan-progress-fill"
            style={{ width: progressWidth }}
          ></div>
        </div>

        <div className="fan-content">{getStepContent()}</div>
        <div className="fan-buttons">
          <button
            className="fan-btn fan-btn-prev"
            onClick={prevStep}
            disabled={step === 1}
          >
            Back
          </button>
          <button
            className="fan-btn fan-btn-next"
            onClick={nextStep}
            disabled={isNextDisabled}
          >
            {step === steps.length ? "Proceed to Checkout" : "Next"}
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BrandPartnershipType;
